import React from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {useAppSelector} from '../../../helpers/reduxHelpers';
import {getAnalyticsPreviousPeriodDatetimes} from '../../../store/panels/analytics/parameters/analyticsPanelParametersSelectors';
import {maybeGetPreviousPeriodFormatter} from '../../helpers/analyticsFormatHelpers';

/*
 * Component.
 */

export const HeroMetricSubtitle = () => {
  const [previousPeriodStart, previousPeriodEnd] = useAppSelector(getAnalyticsPreviousPeriodDatetimes);

  return (
    <Trans id="analytics-report-main-metrics-subtitle">
      All time metrics shown are averages. All comparisons are made with the previous period of the same
      length. Previous period: {maybeGetPreviousPeriodFormatter(previousPeriodStart, previousPeriodEnd)}.
    </Trans>
  );
};
